import store from '../store';
import requestService from './request';
import { APP } from '../utils/constants';
import getCurrentBandwidth from '../utils/bandwidth';

export default async (files, category) => {
  try {
    store.commit(APP.LOADING);

    const apiUrl = process.env.UPLOAD_API_URL;
    const urls = [];
    const bandwidthInMbps = await getCurrentBandwidth();

    for (const file of files) {
      const options = {
        data: {
          category,
          title: file.name,
          extension: file.name.split('.').pop(),
          contentType: file.type,
          sizeInMb: file.sizeInMb,
          bandwidthInMbps,
        },
        localErrorHandling: true,
        useLoading: false,
      };

      const url = await requestService(apiUrl, 'POST', options);

      const optionsUpload = {
        data: file,
        localErrorHandling: true,
        useLoading: false,
        customHeaders: {
          'Content-Type': file.type,
          'x-amz-acl': 'public-read',
        },
      };

      await requestService(url.uploadUrl, 'PUT', optionsUpload);
      urls.push({ url: url.fileUrl, title: file.name });
    }

    return urls;
  } catch (error) {
    throw error;
  } finally {
    store.commit(APP.LOADED);
  }
};



// WEBPACK FOOTER //
// ./src/services/upload.js